import React from 'react';
import { motion } from 'framer-motion';
import { Award, GraduationCap, Building2, BadgeCheck } from 'lucide-react';

const iconMap = {
  Owner: Building2,
  Education: GraduationCap,
  Certification: BadgeCheck,
  Experience: Award,
};

export const IntroSlide = ({ slide }) => {
  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: { staggerChildren: 0.12, delayChildren: 0.2 },
    },
  };

  const itemVariants = {
    hidden: { opacity: 0, x: -30 },
    visible: { opacity: 1, x: 0, transition: { duration: 0.5, ease: 'easeOut' } },
  };

  return (
    <div
      className="h-full w-full flex flex-col justify-center items-center px-8 md:px-12 lg:px-20 py-12"
      data-testid={`slide-${slide.id}`}
    >
      <motion.div
        variants={containerVariants}
        initial="hidden"
        animate="visible"
        className="max-w-4xl w-full"
      >
        {/* Name */}
        <motion.div variants={itemVariants} className="text-center mb-12">
          <p className="font-sans text-lg text-[#D31113] uppercase tracking-[0.3em] mb-4 font-semibold">
            Your Coach
          </p>
          <h2 className="pres-font-heading text-5xl md:text-6xl lg:text-7xl font-black uppercase tracking-tight text-white">
            {slide.title}
          </h2>
        </motion.div>

        {/* Credentials */}
        <div className="space-y-4">
          {slide.credentials?.map((cred, idx) => {
            const Icon = iconMap[cred.label] || Award;
            return (
              <motion.div
                key={idx}
                variants={itemVariants}
                className="flex items-start gap-5 bg-[#2A1D45]/40 backdrop-blur-sm border border-white/10 rounded-xl p-5 hover:border-[#D31113]/30 transition-colors"
              >
                <div className="flex-shrink-0 w-12 h-12 rounded-xl bg-[#D31113]/20 flex items-center justify-center">
                  <Icon className="w-6 h-6 text-[#D31113]" />
                </div>
                <div className="flex-1">
                  <span className="font-sans text-sm text-[#D31113] uppercase tracking-wider font-semibold">
                    {cred.label}
                  </span>
                  <p className="font-sans text-lg md:text-xl text-white mt-1">
                    {cred.value}
                  </p>
                </div>
              </motion.div>
            );
          })}
        </div>
      </motion.div>
    </div>
  );
};
